module.exports = __webpack_public_path__ + "img/Causes-Impact to ESS.29b5316e.svg";